import * as React from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { AppRoutePath } from '@/routes/routeConfig';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        m: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        flexGrow: 1,
        pt: 4,
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '8rem', lineHeight: 1, mb: 2, fontWeight: 'bold' }}>
        404
      </Typography>
      <Box
        component="img"
        src="https://graphdev.morganlewis.net/assets/cave-man-404-Dr8yzO2v.gif"
        alt="404 Not Found"
        sx={{ width: '60vw', maxWidth: 700, minWidth: 300, mb: 3 }}
      />
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        Looks like you&apos;re lost
      </Typography>
      <Typography variant="body1">The page you are looking for is not available.</Typography>
      <Button
        variant="contained"
        disableElevation
        sx={{
          mt: 2.5,
          borderRadius: 999,
          px: 3,
          py: 1.15,
          fontWeight: 700,
          textTransform: 'none',
          fontSize: 16,
          lineHeight: 1,
        }}
        onClick={() => {
          void navigate(AppRoutePath.root);
        }}
      >
        Go to Home
      </Button>
    </Stack>
  );
};

export default NotFound;
